<template>
    <div>
        <table>
            <tr>
                <th>
                    <div class="custom-control custom-radio custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customRadio2"
                            @click="toggleSelect"
                            :checked="selectable"
                        />
                        <label
                            class="custom-control-label"
                            for="customRadio2"
                        ></label>
                    </div>
                </th>
                <th>顧客編號</th>
                <th>顧客名稱</th>
                <th>會員信箱</th>
                <th>使用期限 (?)</th>
                <th>建立時間</th>
            </tr>
            <tbody>
            <tr
                v-for="(user, index) in users"
                :key="index"
                @click.prevent="clickUser(user)"
            >
                <td>
                    <div class="custom-control custom-radio custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :checked="isSelected[index]"
                            :id="`${index}-customRadio1`"
                        />
                        <label
                            class="custom-control-label"
                            :for="`${index}-customRadio1`"
                        ></label>
                    </div>
                </td>
                <td>{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td></td>
                <td>2021/05/24</td>
            </tr>
            </tbody>
            <tr>
                <td>
                    <div class="custom-control custom-radio custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customRadio"
                            onclick="myFunction()"
                        />
                        <label
                            class="custom-control-label"
                            for="customRadio"
                        ></label>
                    </div>
                </td>
                <td>W456</td>
                <td>周杰倫</td>
                <td>信用卡結帳</td>
                <td>7-11超商取貨</td>
                <td>2021/05/24</td>
            </tr>
        </table>
    </div>
</template>
<script>
import Axios from "axios";
import tools from "../../../library/tools";
import ComponentAPIVue from "../../ComponentAPI.vue";

export default {
    extends: ComponentAPIVue,
    data() {
        return {
            selectedUsers: [],
            selectable: false,
            users: [],
        };
    },
    mounted() {
        this.loadCustomers();
    },
    computed: {
        isSelected() {
            return this.users.map((user) => {
                return this.selectable && this.selectedUsers.includes(user.id);
            });
        },
    },
    methods: {
        apiGet(url) {
            return this.apiFormatOutput(Axios.get(url));
        },
        apiHandleError(error) {
            console.log("executed");
            console.log(...arguments);
        },
        clickUser(user) {
            if (this.selectable) {
                this.selectUser(user);
            } else {
                Turbolinks.visit(`${base_url}/admin/customers/${user.id}`);
            }
        },
        range: tools.range,
        selectUser(user) {
            if (this.selectedUsers.includes(user.id)) {
                this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
            } else {
                this.selectedUsers.push(user.id);
            }
        },
        toggleSelect() {
            this.selectable = !this.selectable;
        },
        loadCustomers() {
            this.apiGet(`${base_url}/admin/api/customers`)
                .then((data) => {
                    this.users = data;
                })
                .catch((error) => {
                });
        }
    },
};
</script>
<style lang="scss">
tbody {
    tr {
        padding-left: 2rem;
    }
}
</style>
